import RefreshImg from "public/migrationToMost/wpf_refresh-shield.svg";
import PeopleImg from "public/migrationToMost/fluent_people-team-20-filled.svg";
import serverImg from "public/migrationToMost/fa6-solid_server.svg";
import IntegrationImg from "public/migrationToMost/oui_integration-general.svg";

export const WHY_ONEMIND_CONSTANTS = [
  {
    image: RefreshImg,
    title: "Zero Management Overhead",
    text: "No cluster provisioning, patching, or control plane maintenance required.",
  },
  {
    image: PeopleImg,
    title: "Built-In Observability",
    text: "Prometheus, Grafana, and Elastic Stack pre-integrated for seamless monitoring.",
  },
  {
    image: RefreshImg,
    title: "Compliance-Ready",
    text: "Role-based access control, network policies, and automated backups built-in.",
  },
  {
    image: IntegrationImg,
    title: "CI/CD Native",
    text: "ArgoCD, GitOps workflows, and image scanning baked directly into the platform.",
  },
  {
    image: serverImg,
    title: "Hybrid & Multi-Cluster Support",
    text: "Manage applications across clouds or regions from a unified dashboard.",
  },
];
